/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig';

export class RestoreJobConfiguration {
  'restoreEbsVolume'?: RestoreEbsVolumeConfig | null;
  'convertEbsSnapshot'?: ConvertEbsSnapshotConfig | null;
  'restoreEc2Instance'?: RestoreEc2InstanceConfig | null;
  'convertEc2Image'?: ConvertEc2ImageConfig | null;
  'restoreRdsInstance'?: RestoreRdsInstanceConfig | null;
  'restoreEksNamespace'?: RestoreEksNamespaceConfig | null;
  'restoreDynamoDbTable'?: RestoreDynamoDbTableConfig | null;
  'restoreAzureDisk'?: RestoreAzureDiskConfig | null;
  'restoreAzureVMInstance'?: RestoreAzureVMInstanceConfig | null;
  'restoreGcpCloudSqlDatabase'?: RestoreGcpCloudSqlDatabaseConfig | null;
  'restoreGceDisk'?: RestoreGceDiskConfig | null;
  'restoreGceInstance'?: RestoreGceInstanceConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreEbsVolume",
      "baseName": "restoreEbsVolume",
      "type": "RestoreEbsVolumeConfig",
      "format": ""
    },
    {
      "name": "convertEbsSnapshot",
      "baseName": "convertEbsSnapshot",
      "type": "ConvertEbsSnapshotConfig",
      "format": ""
    },
    {
      "name": "restoreEc2Instance",
      "baseName": "restoreEc2Instance",
      "type": "RestoreEc2InstanceConfig",
      "format": ""
    },
    {
      "name": "convertEc2Image",
      "baseName": "convertEc2Image",
      "type": "ConvertEc2ImageConfig",
      "format": ""
    },
    {
      "name": "restoreRdsInstance",
      "baseName": "restoreRdsInstance",
      "type": "RestoreRdsInstanceConfig",
      "format": ""
    },
    {
      "name": "restoreEksNamespace",
      "baseName": "restoreEksNamespace",
      "type": "RestoreEksNamespaceConfig",
      "format": ""
    },
    {
      "name": "restoreDynamoDbTable",
      "baseName": "restoreDynamoDbTable",
      "type": "RestoreDynamoDbTableConfig",
      "format": ""
    },
    {
      "name": "restoreAzureDisk",
      "baseName": "restoreAzureDisk",
      "type": "RestoreAzureDiskConfig",
      "format": ""
    },
    {
      "name": "restoreAzureVMInstance",
      "baseName": "restoreAzureVMInstance",
      "type": "RestoreAzureVMInstanceConfig",
      "format": ""
    },
    {
      "name": "restoreGcpCloudSqlDatabase",
      "baseName": "restoreGcpCloudSqlDatabase",
      "type": "RestoreGcpCloudSqlDatabaseConfig",
      "format": ""
    },
    {
      "name": "restoreGceDisk",
      "baseName": "restoreGceDisk",
      "type": "RestoreGceDiskConfig",
      "format": ""
    },
    {
      "name": "restoreGceInstance",
      "baseName": "restoreGceInstance",
      "type": "RestoreGceInstanceConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreJobConfiguration.attributeTypeMap;
  }

  public constructor() {
  }
}

